<h1 id="select-account-heading" class="sr-only" tabindex="-1" aria-hidden="false">Select Account</h1>
<div class="form-row-3col mb-6">
  <div class="field-2col">
    <label class="font-bold" for="select-account">Select Account</label>
    <div class="control">
      <button
        id="select-account"
        #actualTarget
        pButton
        label="Add new account"
        icon="pi pi-plus"
        [disabled]="!availableTenants.length || hasSingleHealthPlan"
        (click)="op.show($event, actualTarget)"
      ></button>
      <p-popover #op [pt]="{
         content: 'px-0! py-2!'
         }">
        <ul class="add-tenant-list">
          @for (tenant of availableTenants; track tenant) {
            <li
              class="py-1 px-4 cursor-pointer hover:bg-primary-100"
              (click)="addTenant($event, tenant)"
            >
              {{ tenant.displayName }}
            </li>
          }
        </ul>
      </p-popover>
    </div>
  </div>

  <div class="field-2col">
    <label class="font-bold" for="provider-type">Provider Type:</label>
    <div class="control">
      <p-select
        inputId="provider-type"
        styleClass="provider-type-dropdown"
        placeholder="Select Provider Type"
        [options]="providerTypeOptions"
        [disabled]="isProviderAdded"
        [ngModel]="providerType"
        (onChange)="handleChangeProviderType($event)"
      ></p-select>
    </div>
  </div>
<div class="field-2col" [formGroup]="userInfoForm">
  <label class="font-bold field-required" for="email-input">Preferred Business Email:</label>
  <div class="control">
    <input
      id="email-input"
      type="email"
      pInputText
      class="email-input"
      [class.p-invalid]="emailExists || (emailCtrl?.invalid && (emailCtrl?.dirty || emailCtrl?.touched))"
      formControlName="preferredBusinessEmail"
      autocomplete="email"
      placeholder="Enter email"
      aria-required="true"
    />
  </div>
  @if (emailExists) {
    <div class="p-error field-error">An account with this email address already exists.</div>
  }
  @else if ((emailCtrl?.dirty || emailCtrl?.touched) && emailCtrl?.hasError('required')) {
    <div class="p-error field-error">Email is required.</div>
  }
  @else if ((emailCtrl?.dirty || emailCtrl?.touched) && (emailCtrl?.hasError('pattern') || emailCtrl?.hasError('email'))) {
    <div class="p-error field-error">Must be a valid email address.</div>
  }
  </div>
</div>

@for (account of selectedTenants; track account) {
  <app-account
    [account]="account"
    [isHHProviderType]="isHHProviderType"
    [providers]="selectedProviders[account.tenantId]"
    [selectedBusinessTypeName]="providerType?.businessType"
    (add)="handleAddProvider($event, account)"
    (remove)="handleRemoveProviders($event, account)"
    (deleteAccount)="handleDeleteAccount($event)"
  />
}

<div class="mb-6">
  <app-recaptcha
    (resolved)="handleCaptchaResolve($event)"
    (expired)="handleCaptchaResolve($event)" />
</div>

<div class="flex justify-between">
  <button
    pButton
    type="button"
    icon="pi pi-chevron-left"
    iconPos="left"
    label="Back"
    class="p-button-secondary"
    (click)="goBack.emit()"
    >
  </button>
  <button
    pButton
    type="button"
    label="Submit"
    icon="pi pi-chevron-right"
    iconPos="right"
    [disabled]="!canSubmit"
    (click)="handleSubmit()"
    >
  </button>
</div>

<p-confirmDialog header="Confirmation"></p-confirmDialog>
<p-toast key="error" position="bottom-left" [style]="{'width': '700px'}"></p-toast>
